import moment from 'moment';

export function clearForm(selector) {
    const inputs = document.querySelectorAll(selector);
    for (let i=0; i < inputs.length; i++) {
      inputs[i].value = null;
    }    
}

export function formatDate(date) {
    return moment(date).format('YYYY-MM-DD')
} 

export function formatPayloadDate(date) {
  return moment(date).format('YYYY-MM-DDT00:00:00')
} 

export function formatPhone(phone) {
  phone = phone.replace(/\D/g, '');
  return (phone) ? `(${phone[0]}${phone[1]}${phone[2]}) ${phone[3]}${phone[4]}${phone[5]}-${phone[6]}${phone[7]}${phone[8]}${phone[9]}` : '';
}

export function openModal(id) {
  const interval = setInterval(() => {
    if (document.getElementById(id)) {
      clearInterval(interval);
      document.getElementById(id).classList.add('is-active');
    }
  });
}

export function populateDate(obj) {
    if (obj && !obj.date) obj['date'] = moment().format('YYYY-MM-DD');
}

